import {
  expoTarifasService
} from '../_services';

const state = {}

const actions = {
  /* FECHAS INSCRIPCIONES EXPOSICIONES */
  addNewExpoDateInscr({
    commit,
    dispatch
  }, datos) {

    return new Promise((resolve, reject) => {
      expoTarifasService.addNewExpoDateInscr(datos)
        .then(
          data => {
            dispatch('expos/getOneById', {
              id: datos.expo_id,
              silent: true
            }, {
              root: true
            });
            dispatch('alert/success', 'Registro Creado correctamente', {
              root: true
            })
            return resolve(true);
          },
          error => {
            dispatch('alert/error', {
              text: 'Se ha producido un error al crear el registro',
              data: error
            }, {
              root: true
            })
          }
        );

    });



  },

  /* ACTUALIZAR FECHAS DE INSCRIPCIONES */
  editExpoDateInscr({ dispatch
  }, datos) {
    return new Promise((resolve, reject) => {

      expoTarifasService.editExpoDateInscr(datos)
        .then(
          data => {
            dispatch('expos/getOneById', {
              id: datos.expo_id,
              silent: true
            }, {
              root: true
            });
            dispatch('alert/success', 'Fecha actualizada correctamente', {
              root: true
            })
            return resolve(true);
          },
          error => {
            dispatch('alert/error', {
              text: 'Se ha producido un error al actualizar el registro',
              data: error
            }, {
              root: true
            })
          }
        );
    });
  },

  /* ELIMINAR UNA TARIFA EXISTENTE */
  deleteExpoDateInscr({ dispatch
  }, datos) {
    return new Promise((resolve, reject) => {

      expoTarifasService.deleteExpoDateInscr(datos)
        .then(
          data => {
            dispatch('expos/getOneById', {
              id: datos.expo_id,
              silent: true
            }, {
              root: true
            });
            dispatch('alert/success', 'Fecha actualizada correctamente', {
              root: true
            })
            return resolve(true);
          },
          error => {
            dispatch('alert/error', {
              text: 'Se ha producido un error al actualizar el registro',
              data: error
            }, {
              root: true
            })
          }
        );
    });
  },



}
const mutations = {

}

const getters = {

}

export const expoTarifas = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
